<template>
    <Icon
        name="spinner-third-duotone"
        class="inline-block animate-spin text-grind-400"
    />
</template>
